import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'Password',
  props: {
    callback: {
      type: Function,
      require: true,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      pwd: '',
      rePwd: '',
      pwdError: ''
    };
  },
  computed: {
    isValidator: function isValidator() {
      return this.pwd && this.rePwd && !this.pwdError;
    }
  },
  methods: {
    // 校验密码必须包含字母和数字 6-16位
    checkPwdValidator: function checkPwdValidator() {
      console.log('ddd');

      if (this.pwd === '' || !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(this.pwd)) {
        this.pwdError = '请输入6-16位密码，必须包含字母和数字';
      } else {
        this.pwdError = '';
      }
    },
    onOk: function onOk() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var pwdMd5, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.rePwd !== _this.pwd)) {
                  _context.next = 3;
                  break;
                }

                _this.$message.error('两次密码输入不一致，请重新输入');

                return _context.abrupt("return");

              case 3:
                pwdMd5 = _this.$md5(_this.pwd);
                _context.next = 6;
                return _this.callback(pwdMd5);

              case 6:
                res = _context.sent;

                if (res) {
                  _this.$attrs.close();
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};